import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine17 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M24 11.9998C24 18.6276 18.6272 24.0001 11.9998 24.0001C5.37249 24.0001 0 18.6276 0 11.9998C0 5.37249 5.37249 0 11.9998 0C18.6272 0 24 5.37249 24 11.9998Z",
				fill: "#D2D200"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M6.39401 18.3449V8.35238C5.6198 8.96461 4.39535 9.55879 3.54899 9.93688L2.68533 7.99234C4.01727 7.43423 5.6198 6.58787 6.88033 5.63364H9.09472V18.3449H6.39401ZM15.3402 18.3449H12.4411C12.4411 16.6706 12.8913 15.5901 14.0075 13.5197L17.1044 7.7582H10.9288V5.63364H19.8231V7.70408C17.033 12.5474 15.3402 16.3463 15.3402 18.3449Z",
				fill: "black"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLine17);
export { ForwardRef as ReactComponent };
